module.exports = __webpack_public_path__ + "media/images/top/top_bg_up-f386b2f57aef1cb1577aa96583271671.gif";